<div [matTooltip]="'Comment'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-comment'"
    (click)="selectTool.emit()"
  >
    <fa-icon [icon]="['fal', 'comment']"></fa-icon>
  </button>
</div>
